<template>
    <Dialog
        title="Purchase Shipping Label"
        :open="open"
        @close="emit('close')"
    >
        <EasyPostRateCard
            :rate="rate"
            hide-purchase-button
        />

        <hr>

        <div class="is-width-100 is-flex is-justify-content-space-between is-align-items-center">
            <button
                class="button is-outlined"
                :disabled="isLoading"
            >
                Cancel
            </button>
            <button
                class="button is-primary"
                :class="{
                    'is-loading': isLoading,
                }"
                @click.prevent="handlePurchase"
            >
                Purchase Label
            </button>
        </div>
    </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/Components/Dialog.vue";
import {IRate} from "@easypost/api/types/Shipment";
import {router} from "@inertiajs/vue3";
import {ref} from "vue";
import EasyPostRateCard from "@/Components/EasyPostRateCard.vue";

const props = defineProps<{
    open: boolean;
    rate: IRate;
    fulfillmentOrderId: number;
}>();

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const isLoading = ref(false);

function handlePurchase() {
    router.post(route('admin.self_fulfillment.orders.purchase_rate', {
        fulfillmentOrder: props.fulfillmentOrderId,
    }), {
        rateId: props.rate.id
    }, {
        onStart: () => {
            isLoading.value = true;
        },
        onFinish: () => {
            isLoading.value = false;
        },
        onSuccess: () => {
            emit('close');
        }
    });
}
</script>
